import type { RenamePlan } from '@cli-types/core-engine/snapshots.js'
import { readLocalProjectFile } from '@cli-utils/paths.js'
import { transformContentForRenamePlan } from '@core-engine/snapshots/ast-substitution/transform-content-for-rename-plan.js'

export function validateCustomCellRenameSelections(
  cwd: string,
  selected: RenamePlan['customCells'],
  fieldRenames: RenamePlan['fields']
): { renames: RenamePlan['customCells']; warnings: string[] } {
  const renames: RenamePlan['customCells'] = []
  const warnings: string[] = []

  for (const rename of selected) {
    const validationPlan: RenamePlan = {
      fields: fieldRenames,
      customCells: [rename]
    }
    const validationPaths = [rename.columnsPath, rename.oldPath]
    let valid = true

    for (const validationPath of validationPaths) {
      const content = readLocalProjectFile(cwd, validationPath)
      if (content == null) {
        continue
      }

      const result = transformContentForRenamePlan(content, validationPath, validationPlan)
      if (result.parseFailed) {
        warnings.push(
          `Skipped custom cell rename ${rename.before} -> ${rename.after}: AST parse failed for ${validationPath}`
        )
        valid = false
        break
      }
    }

    if (valid) {
      renames.push(rename)
    }
  }

  return { renames, warnings }
}
